Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "ChallengeCard3006958881",
  {"card":"ChallengeCard3006958881--card","info":"NewCard4213455984--info","media":"NewCard4213455984--media","title":"ChallengeCard3006958881--title","subtitle":"ChallengeCard3006958881--subtitle","subtitleItem":"ChallengeCard3006958881--subtitleItem","pricing":"ChallengeCard3006958881--pricing","infoWrapper":"ChallengeCard3006958881--infoWrapper","divider":"ChallengeCard3006958881--divider","button":"ChallengeCard3006958881--button","imageWrapper":"ChallengeCard3006958881--imageWrapper","root":"ChallengeCard3006958881--root"},
  "",
  8,
  "ChallengeCard3006958881"
);

